<template>
  <div v-if="loadConfigurationGroups" >
    <b-row>
      <b-col cols="2">
        <div>
          <h3>Period</h3>
          <el-select v-model="period" placeholder="Period" @change="periodChanged($event)">
            <el-option v-for="period in periods" :key="period.value" :label="period.label" :value="period.value" />
          </el-select>
        </div>
      </b-col>
      <b-col cols="2">
        <h3>From</h3>
        <base-input type="datetime-local" v-model="from" :required=true @click.native="customPeriod" />
      </b-col>
      <b-col cols="2">
        <h3>Until</h3>
        <base-input type="datetime-local" v-model="until" :required=true @click.native="customPeriod" />
      </b-col>
      <b-col cols="2" v-if="this.showGroup">
        <h3>Group</h3>
        <el-select v-model="group" placeholder="Group">
          <el-option key="ALL" label="All" value="ALL" />
          <el-option v-for="group in groups" v-if="group.active" :key="group.id" :label="group.name" :value="group.id" />
        </el-select>
      </b-col>
      <b-col cols="1">
        <h3>&nbsp;</h3>
        <base-button size="m" type="neutral" @click.native="handleUpdate()" style="float: right;">Update</base-button>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import moment from "moment";
import crudApi from "../../crud/crud-api";
import {Option, Select} from "element-ui";

export default {
  name: "period-filter",
  props: {
    showGroup: {
      type: Boolean,
      required: false,
      default: true,
      description: "Whether group must be shown"
    }
  },
  components: {
    [Select.name]: Select,
    [Option.name]: Option,
  },
  created() {
    this.period = this.$store.state.filter.period
    this.group = this.$store.state.filter.group
    this.from = this.$store.state.filter.from
    this.until = this.$store.state.filter.until
  },
  data: _ => ({
    period: "TODAY",
    periods: [
      {
        value: "TODAY",
        label: "Today"
      },
      {
        value: "YESTERDAY",
        label: "Yesterday"
      },
      {
        value: "THIS_WEEK",
        label: "This week"
      },
      {
        value: "THIS_MONTH",
        label: "This month"
      },
      {
        value: "LAST_WEEK",
        label: "Last week"
      },
      {
        value: "LAST_MONTH",
        label: "Last month"
      },
      {
        value: "THIS_YEAR",
        label: "This year"
      },
      {
        value: "CUSTOM",
        label: "Custom"
      },
    ],
    from: moment().format().slice(0,10) + 'T00:00:01',
    until: moment().format().slice(0,10) + 'T23:59:59',
    group: "ALL",
    groups: undefined
  }),
  computed: {
    loadConfigurationGroups() {
      this.getGroups()

      return true
    }
  },
  watch: {
    period: function () {
      console.log('Period changed')

      this.$store.state.filter.period = this.period
      this.$store.state.filter.from = this.from
      this.$store.state.filter.until = this.until
    },
    from: function () {
      this.$store.state.filter.from = this.from
    },
    until: function () {
      this.$store.state.filter.until = this.until
    },
    group: function () {
      this.$store.state.filter.group = this.group
    },
    '$store.state.auth.user.organisation_id': function() {
      this.group = "ALL"
    },
    '$store.state.filter.period': function () {
      if (this.period != this.$store.state.filter.period) {
        this.period = this.$store.state.filter.period
        this.from = this.$store.state.filter.from
        this.until = this.$store.state.filter.until
      }
    },
    '$store.state.filter.from': function () {
      if (this.from != this.$store.state.filter.from) {
        this.from = this.$store.state.filter.from
      }
    },
    '$store.state.filter.until': function () {
      if (this.until != this.$store.state.filter.until) {
        this.until = this.$store.state.filter.until
      }
    },
    '$store.state.filter.group': function () {
      if (this.group != this.$store.state.filter.group) {
        this.group = this.$store.state.filter.group
      }
    },
  },
  methods: {
    handleUpdate() {
      this.$store.state.filter.update = moment().format()
    },
    getGroups() {
      crudApi.getGroups(this.$store.state.auth.user.organisation_id).then(json => this.groups = json.data ? json.data : json)
    },
    periodChanged(period) {
      this.updateTimes()

      this.$store.state.filter.update = moment().format()
    },
    customPeriod() {
      this.period = "CUSTOM"
    },
    updateTimes() {
      if (this.period === "TODAY") {
        this.from = moment().format().slice(0,10) + 'T00:00:01'
        this.until = moment().format().slice(0,10) + 'T23:59:59'
      } else if (this.period === "YESTERDAY") {
        this.from = moment().subtract(1, 'days').format().slice(0,10) + 'T00:00:01'
        this.until = moment().subtract(1, 'days').format().slice(0,10) + 'T23:59:59'
      } else if (this.period === "THIS_WEEK") {
        this.from = moment().startOf('week').format().slice(0,10) + 'T00:00:01'
        this.until = moment().format().slice(0,10) + 'T23:59:59'
      } else if (this.period === "THIS_MONTH") {
        this.from = moment().startOf('month').format().slice(0,10) + 'T00:00:01'
        this.until = moment().format().slice(0,10) + 'T23:59:59'
      } else if (this.period === "LAST_WEEK") {
        let prevWeekDay = moment().subtract(7, 'days')
        this.from = prevWeekDay.startOf('week').format().slice(0,10) + 'T00:00:01'
        this.until = prevWeekDay.endOf('week').format().slice(0,10) + 'T23:59:59'
      } else if (this.period === "LAST_MONTH") {
        let prevWeekDay = moment().subtract(1, 'months')
        this.from = prevWeekDay.startOf('month').format().slice(0,10) + 'T00:00:01'
        this.until = prevWeekDay.endOf('month').format().slice(0,10) + 'T23:59:59'
      } else if (this.period === "THIS_YEAR") {
        this.from = moment().startOf('year').format().slice(0,10) + 'T00:00:01'
        this.until = moment().format().slice(0,10) + 'T23:59:59'
      }
    },
  }
}
</script>

<style scoped>

</style>
